import React, { useRef } from 'react'
import './Navbox.scss'

const Navbox = (props) => {
  const windowRef = useRef({})

  const handleNavClick = async (path) => {
    // localStorage.setItem('access', JSON.stringify(props.navItems))
    if (!windowRef?.current?.[path] || windowRef?.current?.[path].closed) {
      windowRef.current[path] = window.open(path)
    } else {
      windowRef?.current?.[path].focus()
    }
  }

  if (!Array.isArray(props.navItems) || !props.navItems.length) return null
  return (
    <ul className='navbox'>
      {props.navItems.map((eachItem, index) => {
        //const isSvgImg = eachItem.icon.type !== 'img'
        const isSvgImg = false
        return (
          <li className={`navbox-item`} key={index} onClick={() => handleNavClick(eachItem.path)} title={eachItem.name}>
            <div className={`nav-img  ${isSvgImg ? '' : 'img'}`}>{eachItem.icon}</div>
            <div>{eachItem.name}</div>
          </li>
        )
      })}
    </ul>
  )
}

export default Navbox
